<!-- eslint-disable -->
<template>
  <v-row>
    <v-col cols="12" md="4">
      <!-- Interests -->
      <v-card elevation="2" class="mb-4" v-if="profile?.interests">
        <v-card-title>{{ $t('profile.interests') }}</v-card-title>
        <v-card-text>
          {{ profile.interests }}
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" md="8">
      <!-- Recent Posts -->
      <v-card elevation="2">
        <v-card-title>{{ $t('profile.recentPosts') }}</v-card-title>
        <v-card-text>
          <div v-if="activity?.posts && activity.posts.length > 0">
            <post-card
              v-for="post in activity.posts.slice(0, 5)"
              :key="post.postId"
              :post="post"
              class="mb-3"
            />
          </div>
          <v-alert v-else type="info">
            {{ $t('profile.noPosts') }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
/* eslint-disable */
import PostCard from './PostCard.vue'

defineProps({
  profile: {
    type: Object,
    default: null
  },
  activity: {
    type: Object,
    default: null
  }
})
</script>

<style scoped>
</style>
